import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Auth } from '../components/shelves/Auth';
import { BottomNav } from '../components/shelves/navigation/BottomNav';
import { DynamicNav } from '../components/shelves/navigation/DynamicNav';
import { NavMenu } from '../components/shelves/navigation/NavMenu';
import { LargeNewThreadButton } from '../components/shelves/newThread/LargeNewThreadButton';
import { FloatingNewThreadButton } from '../components/shelves/newThread/FloatingNewThreadButton';

export default function Header() {
  const { status } = useSelector((state) => state.auth);
  const location = useLocation();
  const [isShown, setIsShown] = useState(false);
  const authenticated = status === 'authenticated';
  const isIndexPage = location.pathname === '/';

  const handleNewThreadButton = () => {
    document.getElementById('newThreadDialog').showModal();
  };

  useEffect(() => {
    const offset = 200;
    function onScroll() {
      if (!isShown && window.scrollY > offset) {
        setIsShown(true);
      } else if (isShown && window.scrollY <= offset) {
        setIsShown(false);
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll, { passive: true });
    };
  }, [isShown]);

  return (
    <>
      <nav className="relative flex items-center justify-between gap-3 px-3 py-2 dark:border-gray-300/10 max-[767px]:w-full md:flex-col lg:left-2 lg:mb-7 lg:h-full lg:items-start lg:px-0 lg:py-3 xl:left-0">
        <div className="flex flex-col items-center justify-center">
          <Link
            to="/"
            className="hidden items-center space-x-2 rounded-2xl bg-indigo-50/90 px-3 py-2 text-indigo-900 shadow-sm hover:text-indigo-800 hover:shadow-md focus-visible:text-indigo-800 supports-[backdrop-filter]:bg-indigo-100/30 supports-[backdrop-filter]:backdrop-blur dark:bg-gray-900/90 dark:text-indigo-100 dark:hover:bg-gray-900 dark:hover:text-indigo-200 dark:focus-visible:text-indigo-200 dark:supports-[backdrop-filter]:bg-gray-900/75 md:flex lg:bg-transparent lg:px-2 lg:font-medium lg:shadow-none lg:hover:shadow-none"
          >
            <Icon className="lg:h-9 lg:w-9" icon="carbon:logo-discord" />
            <div className="lg:text-3xl lg:font-semibold">Diskord</div>
          </Link>
          <DynamicNav />
          <div className="mt-4 hidden flex-col md:flex md:items-center md:gap-2 lg:w-full lg:items-start">
            <NavMenu />
          </div>
        </div>
        <div className="flex flex-col items-start gap-8 lg:w-full">
          {authenticated && isIndexPage && isShown ? (
            <>
              <LargeNewThreadButton handleClick={handleNewThreadButton} />
              <FloatingNewThreadButton handleClick={handleNewThreadButton} />
            </>
          ) : (
            ''
          )}

          <Auth />
        </div>
      </nav>
      <BottomNav />
    </>
  );
}
